import { Injectable, OnDestroy } from '@angular/core';

import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class UserIdService extends DataService<string> implements OnDestroy {}
